var map = {
	"./1AGP.png": 24105,
	"./2AGP.png": 43529,
	"./3AGP.png": 62723,
	"components/Catalog/AGP/img/allDoor/Gold/1AGP.png": 24105,
	"components/Catalog/AGP/img/allDoor/Gold/2AGP.png": 43529,
	"components/Catalog/AGP/img/allDoor/Gold/3AGP.png": 62723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59436;